import { RESTAURANT_ZONES_FETCH } from '../action-types/restaurant-zones-types';
import { axiosAction } from '../../utils/axiosAction';

const ENDPOINT = `${process.env.REACT_APP_ENDPOINT_RESTAURANT_ZONES}`;

export const getEntities = (brand, meta?) => async dispatch => {
  return axiosAction.get(
    `${ENDPOINT}?brand=${brand}`,
    RESTAURANT_ZONES_FETCH,
    dispatch,
    { meta },
  );
};
